// extracted by css-extract-rspack-plugin
export default {"duration":"500","ripple":"DL_MIqHWEjAF2AbM","animate":"pYeiHZHnHYqDo6d2","ripple-animation":"G4n3s2SEzaAr9hhS","rippleAnimation":"G4n3s2SEzaAr9hhS"};